/* eslint-disable max-len */
import { Component, Input, OnInit, ElementRef, Inject } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { format, parseISO, getDate, getMonth, getYear } from 'date-fns';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { GroupService } from 'src/app/services/group.service';

@Component({
  selector: 'app-add-edit-group',
  templateUrl: './add-edit-group.component.html',
  styleUrls: ['./add-edit-group.component.scss'],
})
export class AddEditGroupComponent implements OnInit {

  @Input() public group: any;
  currentUser = this.authService.currentUser;
  groupForm;
  dateValue2;
  unsub1;
  loading;
  constructor(
    public firestore: AngularFirestore,
    public modalCtrl: ModalController,
    public groupService: GroupService,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    public toastController: ToastController,
    private el: ElementRef
  ) {

  }

  ngOnInit() { }

  async ionViewDidEnter() {
    console.log('ionViewDidEnter AddEditGroupComponent', this.group);
    this.unsub1 = this.authService.currentAccount.subscribe(async (currentUser) => { this.currentUser = currentUser; });
    this.groupForm = this.formBuilder.group({
      name: [this.group?.name, [Validators.required, Validators.minLength(3)]],
      description: [this.group?.description],
      type: [this.group?.type || 'public', [Validators.required]],
      createdAt: [new Date(), [Validators.required]],
      recentlyActive: [new Date(), [Validators.required]],
    });
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  get errorCtr1() {
    return this.groupForm.controls;
  }

  save() {
    this.loading = true;
    if (this.groupForm.valid) {
      const group = this.groupForm.getRawValue();
      group.admins = [this.currentUser.id];
      this.groupService.createOrUpdateGroup(this.group?.id, group).then(res => {
        this.presentToast(`Congratulations ${this.currentUser.displayName}`, `You have Successfully ${this.group?.id ? 'Updated the' : 'Created a'} Group!`);
        this.modalCtrl.dismiss({updateGroup: true});
        this.loading = false;
      });
    } else {
      Object.keys(this.errorCtr1).forEach(key => {
        console.log(this.errorCtr1[key].valid);
        if (this.errorCtr1[key].valid === false) {
          this.presentToast(`Invalid ${key}`, `Please fill the ${key} Inputs provided!`);
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          if (invalidControl) {
            this.loading = false;
            setTimeout(() => {
              invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 2000);
            return;
          }
        }
      });
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentToast(header, message) {
    const toast = await this.toastController.create({
      header,
      message,
      position: 'middle',
      cssClass: 'spcl-toast',
      duration: 2000
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  ionViewDidLeave() {
    this.unsub1.unsubscribe();
  }

}
